/** Category id from getCadCategories / submitWaterfall customCategory. */
export type CadCategoryId = string;

export interface CadCategoryDefinition {
  id: CadCategoryId;
  label: string;
  /** Original getCadCategories keys that share this label. */
  sourceIds?: string[];
}

export interface GlobalCategoryDiscount {
  categoryId: CadCategoryId;
  selected: boolean; // used only for Reset selected
  cadPercent: number;
  disabled: boolean;
}

/** Pricing waterfall stages returned on each submitWaterfall line item. */
export interface CadLineItemWaterfall {
  lpWithCad: number;
  plpAfterPtd: number;
  plpAfterVd: number;
  plpAfterTbd: number;
  pnpAfterSbd: number;
  pnpAfterDod: number;
  pnpAfterDdp: number;
}

export interface BoqLineItem {
  id: string;
  categoryId: CadCategoryId;
  productName: string;
  sku: string;
  glp: number;
  nlp: number;
  cadPercent: number;
  /** CAD amount from submitWaterfall (`cadVal`). */
  cadAmount?: number;
  /** Unit deal price from submitWaterfall. */
  dealPrice?: number;
  /** Line total from submitWaterfall. */
  lineTotal?: number;
  quantity: number;
  selected: boolean;
  mlp: number;
  /** When true, the pricing waterfall strip is visible under the line item. */
  expanded: boolean;
  waterfall: CadLineItemWaterfall;
}

export interface CadDiscountCategoryGroup {
  categoryId: CadCategoryId;
  label: string;
  items: BoqLineItem[];
}

export interface ManageCadDiscountsState {
  currency: string;
  globalDiscounts: GlobalCategoryDiscount[];
  categoryGroups: CadDiscountCategoryGroup[];
}

/** Raw GET /v2/pricing/getCadCategories payload. */
export type CadCategoriesApiResponse = unknown;

/** Raw POST /v2/pricing/submitWaterfall payload. */
export type CadWaterfallApiResponse = unknown;

export const FETCH_CAD_CATEGORIES_TYPE = "cadDiscounts/fetchCadCategories";
export const SUBMIT_CAD_WATERFALL_TYPE = "cadDiscounts/submitWaterfall";

export interface ManageCadDiscountsDialogProps {
  isOpen: boolean;
  onClose: () => void;
  /** Optional hook for future API persistence; receives current dialog state on save. */
  onSave?: (state: ManageCadDiscountsState) => void;
}



export interface ManageCADSaleItems {
  itemId: string;
  productCode: string;
  duration: number;
  quantity: string;
  glp: string;
  cadVal: number;
  cadPercent: number;
  numberOfDays: number;
  unitCost: number;
  origin: string;
  commercialModel: string;
  mlp: number;
  almp: number;
  pListPrice: number;
  plpVd: number;
  plpTbd: number;
  pNetPrice: number;
  pnpDod: number;
  pnpIncoterms: number;
  pnpPayTerms: number;
  itemTotal: number;
  helperMlp: number;
  mktDisPercent: number;
  ptdPercent: number;
  vdPercent: number;
  tbdPercent: number;
  sbdPercent: number;
  dodPercent: number;
  incoTermPercent: number;
  customsAndLogistics: number;
  addOnSteps: number;
  addOnStepsSla: number;
  addOnStepsHwSla: number;
  addOnStepsDeviceWar: number;
  addOnStepsIpaas: number;
  addOnStepsDeviceSla: number;
  paymentTermsPercent: number;
  isMarketplace: number;
  custom_category: string;
}

export interface ManageCADSaleSummary {
  totalCadDiscount: number;
  totalManagementDiscount: number;
  totalListPrice: number;
  totalDisPercentCount: number;
  totalIncoTermAdjustment: number;
  dealFinalPrice: number;
  disPercentCounts: DisPercentCounts;
}
export interface DisPercentCounts {
  market_discount: MarketDiscount;
  competitive_additional_discount: MarketDiscount;
  partner_tier_discount: MarketDiscount;
  volume_discount: MarketDiscount;
  time_based_discount: MarketDiscount;
  sbd_discount: MarketDiscount;
  dod_discount: MarketDiscount;
}
export interface MarketDiscount {
  hardware: string;
  devices: string;
  sw: string;
  subscription: string;
  sis_services: string;
  third_party_applications?: string;
  third_party?: string;
  additional_items?: string;
  mpw_items?: string;
  ipaas?: string;
  sla_support?: string;
}

export interface CadwaterfallFullfilledPayload {
  data: {
    items: ManageCADSaleItems[];
    summary: Partial<ManageCADSaleSummary>;
  }
}